import React, { Fragment, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { EditableArea, EditableComponent, RefService } from "@magnolia/react-editor";
import { getMagnoliaContext } from "../../../magnolia.service";
import Swiper from "swiper";
import { Navigation, Pagination, EffectFade, Autoplay } from "swiper/modules";

// Uses alternative approach and directly instantiates Swiper instance to create the right swiper html structure (EditableArea is interfering with that)

const ItemsArea = ({ content }) => {
    return (
        <>
            {content["@nodes"].map((nodeName, idx) => (
                <div className="swiper-slide" key={idx}>
                    <EditableComponent key={idx} content={content[nodeName]} />
                </div>
            ))}
        </>
    );
};

const Hero = (props) => {
    const location = useLocation();
    const magnoliaContext = getMagnoliaContext(location);
    const { items } = props;
    const slideCount = items?.["@nodes"]?.length ?? 0;
    const swiperRef = useRef(null);
    const swiperInstance = useRef(null);

    // Arrows, dots and autoplay only exist when there is something to slide through —
    // a single slide renders as a static hero. Re-init when the slide count changes
    // (an author adding/removing slides in the editor).
    const hasMultipleSlides = slideCount > 1;

    useEffect(() => {
        if (!swiperRef.current) return;

        swiperInstance.current = new Swiper(swiperRef.current, {
            modules: [Navigation, Pagination, EffectFade, Autoplay],
            effect: "fade",
            loop: hasMultipleSlides,
            allowTouchMove: hasMultipleSlides && !magnoliaContext?.isMagnolia,
            speed: 1000,
            autoplay: hasMultipleSlides
                ? {
                      delay: 5000,
                      disableOnInteraction: false,
                  }
                : false,
            navigation: hasMultipleSlides
                ? {
                      nextEl: ".swiper-button-next",
                      prevEl: ".swiper-button-prev",
                  }
                : false,
            // Dot navigation (the Pagination module was imported but never configured —
            // the theme ships .swiper-pagination-bullets styles for it).
            pagination: hasMultipleSlides
                ? {
                      el: ".swiper-pagination",
                      clickable: true,
                  }
                : false,
        });

        return () => {
            if (swiperInstance.current) {
                swiperInstance.current.destroy(true, true);
                swiperInstance.current = null;
            }
        };
    }, [hasMultipleSlides]);

    return (
        <div className="slider-area">
            <div className="slider-active nav-style-1">
                <div className="swiper" ref={swiperRef}>
                    <EditableArea content={items} className="swiper-wrapper" customView={ItemsArea} />

                    {hasMultipleSlides && (
                        <Fragment>
                            <div className="swiper-pagination" />

                            {/* Custom Navigation Buttons */}
                            <button className="swiper-button-prev ht-swiper-button-nav">
                                <i className="pe-7s-angle-left" />
                            </button>
                            <button className="swiper-button-next ht-swiper-button-nav">
                                <i className="pe-7s-angle-right" />
                            </button>
                        </Fragment>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Hero;
